module.exports = __webpack_public_path__ + "img/code-html-lg.8793e424.webp";